import styled from 'styled-components';

export const StyledResiliencyPolicyWrapper = styled.div`
  background-color: #f5f5f5;
  padding: 8px;
`;

export const StyledDatePickerWrapper = styled.div`
  padding: 5px;
`;

export const StyledTopPanelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background: white;
  margin-bottom: 10px;
`;

export const StyledTabs = styled.div`
  display: flex;
  min-height: 45px;
  padding: 8px;

  a {
    text-decoration: none;
  }
`;

export const StyledPanel = styled.div`
  background-color: #fff;
  padding: 8px;
`;

export const StyledFilterPanel = styled.div`
  margin-bottom: 10px;
`;
